'use strict';
const _ = require('underscore'),
	mmWidgets = require('./mm-widgets');
mmWidgets.fn.typeahead = function (search, executor, formatter) {
	const ARROW_DOWN = 40,
		ARROW_UP = 38,
		ENTER = 13,
		TAB = 9,
		tabindex = '-1';
	return mmWidgets.each(this, function () {
		const element = this,
			editor = element.find('[data-mm-role=value-editor]'),
			selector = element.find('[data-mm-role=value-selector]'),
			template = element.find('[data-mm-role=template]'),
			stop = function (evt) {
				evt.preventDefault();
				evt.stopPropagation();
				evt.stopImmediatePropagation();
				return true;
			},
			switchToSelector = function () {
				selector.children().first().focus();
			},
			switchToPreviousSelector = function (target) {
				const prev = target.prev();
				if (prev.length) {
					prev.focus();
				} else {
					editor.focus();
					if (editor.domElements.length) {
						editor.domElements[0].setSelectionRange(editor.val().length, editor.val().length);
					}

				}
			},
			switchToNextSelector = function (targetEl) {
				const next = targetEl.next();
				if (next.length) {
					next.focus();
				}
			},
			attachListeners = function (target) {
				target.on('keydown', function (e) {
					switch (e.which) {
						case ARROW_DOWN: return stop(e) && switchToNextSelector(target);
						case TAB: return stop(e) && (e.shiftKey ?  switchToPreviousSelector(target) : switchToNextSelector(target));
						case ARROW_UP: return stop(e) && switchToPreviousSelector(target);
						case ENTER: return stop(e) && executor(target.data('value'));
					}
				}).on('click', function (e) {
					return stop(e) && executor(target.data('value'));
				});
			},
			firstSelectorValue = function () {
				return selector.children().first().data('value');
			},
			rebuildSelector = function () {
				const searchFor = editor.val(),
					options = searchFor && search(searchFor);

				selector.empty();
				if (_.isEmpty(options)) {
					selector.addClass('hidden');
				} else {
					selector.removeClass('hidden');
					options.forEach(function (option) {
						const newElement = template.clone().appendTo(selector).attr('tabindex', tabindex).data('value', option);
						attachListeners(newElement);
						if (formatter) {
							formatter(newElement, option, searchFor);
						} else {
							newElement.text(option);
						}
					});
				}
			};
		template.remove();
		editor.on('input', rebuildSelector).on('keydown', function (e) {
			switch (e.which) {
				case ARROW_DOWN: case TAB: return stop(e) && switchToSelector();
				case ENTER: return stop(e) && executor(firstSelectorValue() || e.target.value);
			}
		});
		element.on('show', function () {
			editor.val('');
			selector.empty().addClass('hidden');
		});
		editor.attr('tabindex', tabindex);
	});
};
